export const companyDetails = {
  name: "Ranjitham Crackers Gallery",
  address: " No 1055/3A,1B2,Periyar Colony,Keela Thiruthangal,Sivakasi",
  phone: "9500-139-626",
  email: "kskmohankumar12@gmail.com",
};

export const Products = [
  {
    Title: "ONE SOUND CRACKERS",
    product: '4" GOLD LAKSHMI (5 PCS)',
    unit: "1 PKT",
    price: 100,
    name: "4goldlakshmi5pcs",
  },
  {
    product: '2 ¾" KURUVI  ( 5PCS )',
    unit: "1 PKT",
    price: 24,
    name: "2¾kuruvi5pcs",
  },
  {
    product: '2 ¾" KURUVI SPECIAL ( 5 PCS )',
    unit: "1 PKT",
    price: 40,
    name: "2¾kuruvispecial5pcs",
  },
  {
    product: '3 ½" LAKSHMI ( 5 PCS )',
    unit: "1 PKT",
    price: 50,
    name: "3½lakshmi5pcs",
  },
  {
    product: '4" LAKSHMI ( 5 PCS )',
    unit: "1 PKT",
    price: 67,
    name: "4lakshmi5pcs",
  },
  {
    product: '4" DLX LAKSHMI ( 5 PCS )',
    unit: "1 PKT",
    price: 100,
    name: "4dlxlakshmi5pcs",
  },
  {
    product: "4'' MORI DLX ( 16 PLY )  ( 5 PCS )",
    unit: "1 PKT",
    price: 166,
    name: "4moridlx16ply5pcs",
  },
  {
    product: '5" JALLI KATTU ( 20 PLY )  ( 5 PCS )',
    unit: "1 PKT",
    price: 200,
    name: "5jallikattu20ply5pcs",
  },
  {
    product: "2 SOUND CRACKERS ( 5 PCS )",
    unit: "1 PKT",
    price: 134,
    name: "2soundcrackers5pcs",
  },

  {
    Title: "GROUND CHAKKARS",
    product: "G. CHAKKERS BIG 10 Pcs",
    unit: "1 BOX",
    price: 140,
    name: "gchakkersbig10pcs",
  },
  {
    product: "G. CHAKKERS BIG 25 Pcs",
    unit: "1 BOX",
    price: 280,
    name: "gchakkersbig25pcs",
  },
  {
    product: "G. CHAKKERS SPECIAL (10 Pcs)",
    unit: "1 BOX",
    price: 260,
    name: "gchakkersspecial10pcs",
  },
  {
    product: "G. CHAKKERS DELUXE (10 Pcs)",
    unit: "1 BOX",
    price: 440,
    name: "gchakkersdeluxe10pcs",
  },
  {
    Title: "FLOWER POTS",
    product: "FLOWER POTS BIG (10 Pcs)",
    unit: "1 BOX",
    price: 240,
    name: "flowerpotsbig10pcs",
  },
  {
    product: "FLOWER POTS SPECIAL (10 Pcs)",
    unit: "1 BOX",
    price: 320,
    name: "flowerpotsspecial10pcs",
  },
  {
    product: "FLOWER POTS ASOKA ( 10 PCS)",
    unit: "1 BOX",
    price: 360,
    name: "flowerpotsasoka10pcs",
  },
  {
    product: "FLOWER POTS COLOUR KOTTI ( 10 PCS )",
    unit: "1 BOX",
    price: 640,
    name: "flowerpotscolourkotti10pcs",
  },
  {
    product: "COLOUR KOTTI (MORI) ( 10 PCS )",
    unit: "1 BOX",
    price: 880,
    name: "colourkottimori10pcs",
  },
  {
    product: "FLOWER POTS DELUXE (5 Pcs)",
    unit: "1 BOX",
    price: 520,
    name: "flowerpotsdeluxe5pcs",
  },
  {
    product: "BARATH KOTI 2 Pc (MORI)",
    unit: "1 BOX",
    price: 640,
    name: "barathkoti2pcs",
  },
  {
    Title: "BOMB",
    product: "BULLET BOMB ( 10 PCS )",
    unit: "1 BOX",
    price: 88,
    name: "bulletbomb10pcs",
  },
  {
    product: "HYDRO BOMB ( 10 PCS )",
    unit: "1 BOX",
    price: 240,
    name: "hydrobomb10pcs",
  },
  {
    product: "KING OF KING BOMB ( 10 PCS )",
    unit: "1 BOX",
    price: 352,
    name: "kingofkingbomb10pcs",
  },
  {
    product: "CLASSIC BOMB / COMMANDER BOMB ( 10 PCS)",
    unit: "1 BOX",
    price: 432,
    name: "classicbombcommanderbomb10pcs",
  },
  {
    product: "GODZILLA BOMB ( 10 PCS)",
    unit: "1 BOX",
    price: 736,
    name: "godzillabomb10pcs",
  },
  {
    product: "AGNI BOMB / ANIMAL BOMB (10 PCS )",
    unit: "1 BOX",
    price: 768,
    name: "agnibombanimalbomb10pcs",
  },
  {
    Title: "BIJILI PACKETS",
    product: "50 RED CHILLIS",
    unit: "1 PKT",
    price: 80,
    name: "50redchillis",
  },
  {
    product: "100 RED CHILLIS",
    unit: "1 PKT",
    price: 160,
    name: "100redchillis",
  },
  {
    product: "100 SPL RED CHILLIS",
    unit: "1 PKT",
    price: 240,
    name: "100splredchillis",
  },
  {
    Title: "CHILDREN'S ATTRACTION",
    product: "1 ½' TWINKLING STAR / JIL JIL (10 PCS)",
    unit: "1 BOX",
    price: 83.0,
    name: "112twinklingstar",
  },
  {
    product: "4' TWINKLING STAR (10 PCS)",
    unit: "1 BOX",
    price: 235.0,
    name: "4twinklingstar",
  },
  {
    product: "KIT KAT (10 PCS)",
    unit: "1 BOX",
    price: 100.0,
    name: "kitkat",
  },
  {
    product: "NAUGHTY BOY (10 PCS)",
    unit: "1 BOX",
    price: 176.0,
    name: "naughtyboy",
  },
  {
    product: "STONE (10 PCS)",
    unit: "1 BOX",
    price: 38.0,
    name: "stone",
  },
  {
    product: "ZEE BBOM BAA / MAGIC POPS (10 PCS)",
    unit: "1 BOX",
    price: 34.0,
    name: "magicpops",
  },
  {
    product: "SERPENT EGG BIG (5 PCS)",
    unit: "1 UNIT",
    price: 100.0,
    name: "serpentegg",
  },
  {
    product: "ANACONDA (10 PCS)",
    unit: "1 BOX",
    price: 300.0,
    name: "anaconda",
  },
  {
    product: "ROLL CAPS (10 PCS)",
    unit: "1 BOX",
    price: 280.0,
    name: "rollcaps",
  },
  {
    product: "ASSORTED CARTOON (5 PCS)",
    unit: "1 BOX",
    price: 70.0,
    name: "assortedcartoon",
  },
  {
    product: "PILI CRACKERS (10 PC)",
    unit: "1 BOX",
    price: 468.0,
    name: "pilicrackers",
  },
  {
    product: "WONDER THROW (10 BOXES)",
    unit: "1 BOX",
    price: 500.0,
    name: "wonderthrow",
  },
  {
    product: "RACING CAR (2 PC)",
    unit: "1 BOX",
    price: 670.0,
    name: "racingcar",
  },
  {
    product: "SMOKY STICK (YELLOW & BLUE) (2PCS)",
    unit: "1 BOX",
    price: 50.0,
    name: "smokystick",
  },
  {
    Title: "IN THE AIR",
    product: "ROCKET BOMB ( 10 PC )",
    unit: "1 BOX",
    price: 230,
    name: "rocketbomb10pc",
  },
  {
    product: "2 SOUND ROCKET ( 10 PCS )",
    unit: "1 BOX",
    price: 384,
    name: "2soundrocket10pcs",
  },
  {
    product: "WHISTLING ROCKET ( 10 PCS )",
    unit: "1 BOX",
    price: 550,
    name: "whistlingrocket10pcs",
  },
  {
    product: "SINGING DOLL / WHISTLING SHOT( 1 PC )",
    unit: "1 BOX",
    price: 670,
    name: "singingdollwhistlingshot1pc",
  },
  {
    product: "SKY LANTERN / PARACHUTE ( 1 PC )",
    unit: "1 PCS",
    price: 170,
    name: "skylanternparachute1pc",
  },
  {
    Title: "FOUNTAINS",
    product: "FEARTHER (5 PCS )",
    unit: "1 BOX",
    price: 280,
    name: "fearther5pcs",
  },
  {
    product: "DISCO SHOWER ( 5 PCS )",
    unit: "1 BOX",
    price: 300,
    name: "discoshower5pcs",
  },
  {
    product: "KJ POT / COLOUR WAR MIXING (5 PCS )",
    unit: "1 BOX",
    price: 560,
    name: "kjpotcolourwarmixing5pcs",
  },
  {
    product: "TRI COLOUR ( 5 COLOURS WITH CRACKLING (5 PCS )",
    unit: "1 BOX",
    price: 800,
    name: "tricolour5colourscrackling5pcs",
  },
  {
    product: "COLOUR RAIN / GOLDEN GLOBE ( 5 PCS )",
    unit: "1 BOX",
    price: 260,
    name: "colourraingoldenglobe5pcs",
  },
  {
    product: "POLO / CHOTTA BHEEM (1 PC )",
    unit: "1 BOX",
    price: 110,
    name: "polochottabheem1pc",
  },
  {
    product: "TEDDY / KUR KUR ( 1 PC )",
    unit: "1 BOX",
    price: 170,
    name: "teddykurkur1pc",
  },
  {
    product: "APPLE / ORANGE ( 6 PC )",
    unit: "1 BOX",
    price: 550,
    name: "appleorange6pc",
  },
  {
    product: "FLY MAGIC / TEEN TITANS ( 6 PCS )",
    unit: "1 BOX",
    price: 560,
    name: "flymagicteentitans6pcs",
  },
  {
    product: "ICE CREAM CART (5 PCS)",
    unit: "1 BOX",
    price: 370,
    name: "icecreamcart5pcs",
  },
  {
    product: "KNOCK OUT ( 2 PC )",
    unit: "1 BOX",
    price: 500,
    name: "knockout2pc",
  },
  {
    Title: "HOLD ON HAND",
    product: "WIRE CHAKKAR (10 PCS)",
    unit: "1 BOX",
    price: 500,
    name: "wirechakkar10pcs",
  },
  {
    product: "ULTRA PENCIL (3 PC)",
    unit: "1 BOX",
    price: 200,
    name: "ultrapencil3pc",
  },
  {
    product: "POP CORN / WATER FALL (5 PCS)",
    unit: "1 BOX",
    price: 600,
    name: "popcornwaterfall5pcs",
  },
  {
    product: "SIVAKASI SPECIAL (2 PCS)",
    unit: "1 BOX",
    price: 550,
    name: "sivakasispecial2pcs",
  },
  {
    product: "SMOKE (3 PCS)",
    unit: "1 BOX",
    price: 500,
    name: "smoke3pcs",
  },
  {
    product: "SMILE PLEASE (10 PC)",
    unit: "1 BOX",
    price: 500,
    name: "smileplease10pc",
  },
  {
    product: "FUJI CANDLE (5 PCS)",
    unit: "1 BOX",
    price: 800,
    name: "fujicandle5pcs",
  },
  {
    product: "ROTATING SPARKLERS (1 PC)",
    unit: "1 BOX",
    price: 600,
    name: "rotatingsparklers1pc",
  },
  {
    product: "RAINBOW COLOUR (3 COLOURS IN 1) (3 PCS)",
    unit: "1 BOX",
    price: 830,
    name: "rainbowcolour3pcs",
  },
  {
    product: "LOLLI POP (5 PCS)",
    unit: "1 BOX",
    price: 600,
    name: "lollipop5pcs",
  },

  {
    Title: "DAY SPECIAL",
    product: "MONEY MONEY / ROSE PETAL (2 PCS)",
    unit: "1 BOX",
    price: 1170,
    name: "moneymoneyrosepetal2pcs",
  },
  {
    product: "OLD IS GOLD (25 PCS)",
    unit: "1 BOX",
    price: 608,
    name: "oldisgold25pcs",
  },
  // COLOURS IN THE SKY
  {
    product: '1" AERIAL OUT (1 PC)',
    unit: "1 BOX",
    price: 100,
    name: "1aerialout1pc",
  },
  {
    product: "PENTA 5 IN 1 / COLOR COLLECTION (5 PCS)",
    unit: "1 BOX",
    price: 500,
    name: "penta5in1colorcollection5pcs",
  },
  {
    product: "WAR (3 PC)",
    unit: "1 BOX",
    price: 667,
    name: "war3pc",
  },
  {
    product: '2" AERIAL OUT (3 PCS)',
    unit: "1 BOX",
    price: 700,
    name: "2aerialout3pcs",
  },
  {
    product: '2" AERIAL OUT (1 PC)',
    unit: "1 BOX",
    price: 384,
    name: "2aerialout1pc",
  },
  {
    product: '3½" AERIAL OUT (1 PC)',
    unit: "1 BOX",
    price: 750,
    name: "3halfaerialout1pc",
  },
  {
    product: '4" AERIAL OUT (GOLDEN EYE / NAYAGARA) (1 PC)',
    unit: "1 BOX",
    price: 1170,
    name: "4aerialoutgoldeneyenayagara1pc",
  },
  {
    product: '4" AERIAL OUT (2 PCS)',
    unit: "1 BOX",
    price: 2000,
    name: "4aerialout2pcs",
  },
  {
    product: '5" AERIAL OUT (1 PC)',
    unit: "1 BOX",
    price: 1800,
    name: "5aerialout1pc",
  },

  // COLOURS IN THE SKY WITH CRACKLING
  {
    product: "TEXAS DELIGHT / CRACKLING (1 PC)",
    unit: "1 BOX",
    price: 1335,
    name: "texasdelightcrackling1pc",
  },
  {
    product: '4" AERIAL OUT (1 PC)',
    unit: "1 BOX",
    price: 1250,
    name: "4aerialout1pc_crackling",
  },
  {
    product: '4" AERIAL OUT (2 PCS)',
    unit: "1 BOX",
    price: 2500,
    name: "4aerialout2pcs_crackling",
  },
  {
    product: '4" DOUBLE BALL (1 PC)',
    unit: "1 BOX",
    price: 1335,
    name: "4doubleball1pc",
  },
  {
    product: '4½" AERIAL OUT (2 PCS)',
    unit: "1 BOX",
    price: 3000,
    name: "4halfaerialout2pcs",
  },
  {
    product: "CANDY CRUSH / PINTO (9 MEGA DISPLAY)",
    unit: "1 BOX",
    price: 1500,
    name: "candycrushpinto9megadisplay",
  },

  // MULTI COLOURS IN ONE
  {
    product: "12 SHOT RIDER (R & G)",
    unit: "1 BOX",
    price: 520,
    name: "12shotriderrg",
  },
  {
    product: "LOVE DOSE (6 MULTICOLOURS SHOT)",
    unit: "1 BOX",
    price: 300,
    name: "lovedose6multicoloursshot",
  },
  {
    product: "HONEY MOON (12 SHOTS)",
    unit: "1 BOX",
    price: 928,
    name: "honeymoon12shots",
  },
  {
    product: "10 SHOT (MULTI COLOURS)",
    unit: "1 BOX",
    price: 600,
    name: "10shotmulticolours",
  },
  {
    product: "15 SHOT (MULTI COLOURS)",
    unit: "1 BOX",
    price: 900,
    name: "15shotmulticolours",
  },
  {
    product: "30 SHOT (MULTI COLOURS)",
    unit: "1 BOX",
    price: 1280,
    name: "30shotmulticolours",
  },
  {
    product: "60 SHOT (MULTI COLOURS)",
    unit: "1 BOX",
    price: 2560,
    name: "60shotmulticolours",
  },
  {
    product: "120 SHOT (MULTI COLOURS)",
    unit: "1 BOX",
    price: 5120,
    name: "120shotmulticolours",
  },
  {
    product: "HALDI 120 SHOT MORI",
    unit: "1 BOX",
    price: 6000,
    name: "haldi120shotmori",
  },
  {
    product: "240 SHOT (MULTI COLOURS)",
    unit: "1 BOX",
    price: 9500,
    name: "240shotmulticolours",
  },
  {
    product: "PUBG 20 SHOTS (5 X 4)",
    unit: "1 BOX",
    price: 2000,
    name: "pubg20shots5x4",
  },
  {
    product: "10 X 10 MEGA DISPLAY",
    unit: "1 BOX",
    price: 11150,
    name: "10x10megadisplay",
  },
  {
    Title: "COLOURFUL NIGHT",
    product: "PEACOCK (3 WAY)",
    unit: "1 BOX",
    price: 500,
    name: "peacock3way",
  },
  {
    product: "MAGICAL PEACOCK (5 WAY)",
    unit: "1 BOX",
    price: 540,
    name: "magicalpeacock5way",
  },
  {
    product: "BAADA PEACOCK",
    unit: "1 BOX",
    price: 1160,
    name: "baadapeacock",
  },
  {
    product: "5 IN 1",
    unit: "1 BOX",
    price: 1000,
    name: "fiveinone",
  },
  {
    product: "SUNFLOWER POPS MORI (5 PCS)",
    unit: "1 BOX",
    price: 900,
    name: "sunflowerpopsmori5pcs",
  },
  {
    product: "MOJITO / TROPICAL (3 PCS)",
    unit: "1 BOX",
    price: 1200,
    name: "mojitotropical3pcs",
  },
  {
    product: "HOT COOKIES / CIRCUS (5PCS)",
    unit: "1 BOX",
    price: 700,
    name: "hotcookiescircus5pcs",
  },
  {
    product: "TOY FOUNTAIN (2 PC)",
    unit: "1 BOX",
    price: 675,
    image: require('../assets/images/dragon.jpeg'),
    name: "toyfountain2pc",
  },
  {
    product: "ROYALE (1 PC)",
    unit: "1 BOX",
    price: 400,
    name: "royale1pc",
  },
  {
    product: "7 SHOTS (5 PCS)",
    unit: "1 BOX",
    price: 300,
    name: "7shots5pcs",
  },
  {
    product: "MINI SIRAN",
    unit: "1 BOX",
    price: 450,
    name: "minisiran",
  },
  {
    product: "TIN SHOWER (1 PC)",
    unit: "1 BOX",
    price: 250,
    name: "tinshower1pc",
  },
  {
    product: "BUTTERFLY (RED & GREEN) (10 PCS)",
    unit: "1 BOX",
    price: 260,
    name: "butterflyredgreen10pcs",
  },
  {
    product: "BAMBARA (RED & GREEN) (10 PCS)",
    unit: "1 BOX",
    price: 350,
    name: "bambararedgreen10pcs",
  },
  {
    product: "WHISTLING DIXIE (5 PCS)",
    unit: "1 BOX",
    price: 350,
    name: "whistlingdixie5pcs",
  },
  {
    product: "COCKTAIL (3 PC)",
    unit: "1 BOX",
    price: 700,
    name: "cocktail3pc",
  },
  {
    product: "SIREN (3 PCS)",
    unit: "1 BOX",
    price: 565,
    name: "siren3pcs",
  },
  {
    product: "4X4 WHEEL (5 PCS)",
    unit: "1 BOX",
    price: 536,
    name: "4x4wheel5pcs",
  },
  {
    product: "BLACK MONEY / MONEY BLAST (5 PCS)",
    unit: "1 BOX",
    price: 770,
    name: "blackmoneymoneyblast5pcs",
  },
  {
    product: "5 STAR (STEP BY STEP 5 COLOURS) (1 PC)",
    unit: "1 BOX",
    price: 960,
    name: "fivestarstep5colors1pc",
  },
  {
    product: "CRACKLING FOUNTAIN (3 PCS)",
    unit: "1 BOX",
    price: 900,
    name: "cracklingfountain3pcs",
  },
  {
    product: "STAR KING (1 PC)",
    unit: "1 BOX",
    price: 380,
    name: "starking1pc",
  },
  ,
  {
    Title: "SPARKLERS",
    product: "7 CM ELECTRIC SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 30,
    name: "7cm_electric_sparklers_10pcs",
  },
  {
    product: "7 CM COLOUR SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 36,
    name: "7cm_colour_sparklers_10pcs",
  },
  {
    product: "7 CM GREEN SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 45,
    name: "7cm_green_sparklers_10pcs",
  },
  {
    product: "7 CM RED SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 50,
    name: "7cm_red_sparklers_10pcs",
  },
  {
    product: "10 CM ELECTRIC SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 56,
    name: "10cm_electric_sparklers_10pcs",
  },
  {
    product: "10 CM COLOUR SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 62,
    name: "10cm_colour_sparklers_10pcs",
  },
  {
    product: "10 CM GREEN SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 64,
    name: "10cm_green_sparklers_10pcs",
  },
  {
    product: "10 CM RED SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 70,
    name: "10cm_red_sparklers_10pcs",
  },
  {
    product: "12 CM ELECTRIC SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 70,
    name: "12cm_electric_sparklers_10pcs",
  },
  {
    product: "12 CM COLOUR SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 76,
    name: "12cm_colour_sparklers_10pcs",
  },
  {
    product: "12 CM GREEN SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 84,
    name: "12cm_green_sparklers_10pcs",
  },
  {
    product: "12 CM RED SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 92,
    name: "12cm_red_sparklers_10pcs",
  },
  {
    product: "15 CM ELECTRIC SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 130,
    name: "15cm_electric_sparklers_10pcs",
  },
  {
    product: "15 CM COLOUR SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 145,
    name: "15cm_colour_sparklers_10pcs",
  },
  {
    product: "15 CM GREEN SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 158,
    name: "15cm_green_sparklers_10pcs",
  },
  {
    product: "15 CM RED SPARKLERS (10 PCS)",
    unit: "1 BOX",
    price: 170,
    name: "15cm_red_sparklers_10pcs",
  },
  {
    product: "15 CM SILVER DROPS (10 PCS)",
    unit: "1 BOX",
    price: 175,
    name: "15cm_silver_drops_10pcs",
  },
  {
    product: "15 CM PINK (10 PCS)",
    unit: "1 BOX",
    price: 180,
    name: "15cm_pink_10pcs",
  },
  {
    product: "30 CM ELECTRIC SPARKLERS (5 PCS)",
    unit: "1 BOX",
    price: 130,
    name: "30cm_electric_sparklers_5pcs",
  },
  {
    product: "30 CM COLOUR SPARKLERS (5 PCS)",
    unit: "1 BOX",
    price: 145,
    name: "30cm_colour_sparklers_5pcs",
  },
  {
    product: "30 CM GREEN SPARKLERS (5 PCS)",
    unit: "1 BOX",
    price: 158,
    name: "30cm_green_sparklers_5pcs",
  },
  {
    product: "30 CM RED SPARKLERS (5 PCS)",
    unit: "1 BOX",
    price: 170,
    name: "30cm_red_sparklers_5pcs",
  },
  {
    product: "50 CM ELECTRIC SPARKLERS (5 PCS)",
    unit: "1 BOX",
    price: 550,
    name: "50cm_electric_sparklers_5pcs",
  },
  {
    product: "50 CM COLOUR SPARKLERS (5 PCS)",
    unit: "1 BOX",
    price: 580,
    name: "50cm_colour_sparklers_5pcs",
  },
  {
    Title: "COLOUR MATCHES",
    product: "GLAMOUR 3 IN 1",
    unit: "1 PKT",
    price: 80,
    name: "glamour_3in1",
  },
  {
    product: "GALAXY 5 IN 1",
    unit: "1 BOX",
    price: 100,
    name: "galaxy_5in1",
  },
  {
    product: "5 MEN ARMY (5 IN 1)",
    unit: "1 BOX",
    price: 170,
    name: "5men_army_5in1",
  },
  {
    product: "DHASARA SUPER FINE (10 IN 1)",
    unit: "1 BOX",
    price: 550,
    name: "dhasara_superfine_10in1",
  },
  {
    Title: "GIFT BOXES (NET RATE)",
    product: "21 ITEM GIFT BOX",
    unit: "1 BOX",
    price: 350,
    name: "21item_giftbox",
  },
  {
    product: "31 ITEM GIFT BOX",
    unit: "1 BOX",
    price: 400,
    name: "31item_giftbox",
  },
  {
    product: "35 ITEM GIFT BOX",
    unit: "1 BOX",
    price: 500,
    name: "35item_giftbox",
  },
  {
    product: "41 ITEM GIFT BOX",
    unit: "1 BOX",
    price: 650,
    name: "41item_giftbox",
  },
  {
    product: "51 ITEM GIFT BOX",
    unit: "1 BOX",
    price: 900,
    name: "51item_giftbox",
  },
  // {

  // {

  //   Title: "GARLANDS MEGA",
  //   product: "1000 WALA (S)",
  //   unit: "1 BOX",
  //   price: 500,
  //   name: "1000wala_s",
  // },
  // {
  //   product: "1000 WALA (L)",
  //   unit: "1 BOX",
  //   price: 1000,
  //   name: "1000wala_l",
  // },
  // {
  //   product: "2000 WALA (S)",
  //   unit: "1 BOX",
  //   price: 1000,
  //   name: "2000wala_s",
  // },
  // {
  //   product: "2000 WALA SPL (L)",
  //   unit: "1 BOX",
  //   price: 2000,
  //   name: "2000wala_spl_l",
  // },
  // {
  //   product: "5000 WALA (S)",
  //   unit: "1 BOX",
  //   price: 2500,
  //   name: "5000wala_s",
  // },
  // {
  //   product: "5000 WALA SPL (L)",
  //   unit: "1 BOX",
  //   price: 5000,
  //   name: "5000wala_spl_l",
  // },
  // {
  //   product: "1/4 PAPER BOMB",
  //   unit: "1 BOX",
  //   price: 150,
  //   name: "quarter_paper_bomb",
  // },
  // {
  //   product: "1/2 PAPER BOMB",
  //   unit: "1 BOX",
  //   price: 300,
  //   name: "half_paper_bomb",
  // },
];
export const api =
  "https://script.google.com/macros/s/AKfycbzICboUNMBvShj9G0Hh8bhKcX7fd8fphY_CR-0I35MNNqtWgulx-ab-Y0XflZpW5mVC/exec";
export const UserDetails = [
  {
    name: "Name",
  },
  {
    name: "City",
  },
  {
    name: "District",
  },
  {
    name: "Pincode",
  },
  {
    name: "Whatsapp",
  },
];
